module.exports = __webpack_public_path__ + "static/img/smallapp_preview1.3f6e6b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/preview/smallapp_preview1.png
// module id = Vhs9
// module chunks = 1